import { render } from "./InboxView.vue?vue&type=template&id=6e4f4b20&scoped=true"
import script from "./InboxView.vue?vue&type=script&lang=js"
export * from "./InboxView.vue?vue&type=script&lang=js"

import "./InboxView.vue?vue&type=style&index=0&id=6e4f4b20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4f4b20"]])

export default __exports__